import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useAuthState } from "../../../../helper/Context/context";
import { Layout, Users, Video } from "react-feather";


export const AdminSidebar = (props) => {

    const { isopen, active, subMenu, setIsOpen } = props

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token, UserFullName, RoleID } = userDetails

    // const [toggleactive, settoggleactive] = useState("dashboard")
    const [ReportOpen, setReportOpen] = useState(false)
    const [Open, setOpen] = useState(false)


    const [AdminReportOpen, setAdminReportOpen] = useState(false)

    const [Expand, setExpand] = useState(false)

    const ExpandSidebar = (value) => {
        if (value == 'Enter') {
            setIsOpen(true)
            // console.log('Enter')
        } else {
            setIsOpen(false)
            // console.log('Leave')
        }
    }
    return (
        <div

            className="left-slidebar m-0"
            style={(isopen) ? { width: "220px", top: '100px', background: '#1D456F' } : { display: 'none' }}

        >
            {/* <div className="navbar-brand-wrapper d-flex align-items-center justify-content-center ">
                <span className="navbar-brand brand-logo bg-white rounded p-1">
                    <img
                        style={{ width: (isopen || Expand) ? "100%" : "100%" }}
                        src="static/assets/img/nav/logo.png"
                        className="logo"
                        alt="logo"
                    />
                </span>
            </div> */}

            <nav
                className="sidebar sidebar-offcanvas" id="sidebar"
                style={{ maxHeight: (isopen || Expand) ? "" : " calc(100vh - 150px)" }}
            >
                <ul className="nav d-block">

                    <li
                        className={Open || active === "dashboard" ? "nav-item active" : "nav-item sidebar_item"}>

                        <Link to='/MainDashboard' className="nav-link">

                            {/* <img src="static/assets/img/nav/dashboard.png" className="menu-icon" /> */}
                            <Layout className="menu-icon bg-transparent" />
                            <span
                                className="menu-title"
                                style={{ display: (isopen || Expand) ? "" : "none" }}
                            >
                                Dashboard
                            </span>

                        </Link>

                    </li>



                    <li
                        className={Open || active === "dashboard" ? "nav-item active" : "nav-item sidebar_item"}>

                        <Link to='/UpcomingSeminar' className="nav-link">

                            <img src="static/assets/img/sidebaricons/upcomingSeminar.png" className="menu-icon bg-transparent p-0 m-0 shadow-none" />
                            {/* <Users className="menu-icon bg-transparent" /> */}
                            <span
                                className="menu-title"
                                style={{ display: (isopen || Expand) ? "" : "none" }}
                            >
                                Upcoming Seminar
                            </span>

                        </Link>

                    </li>


                    <li
                        className={Open || active === "dashboard" ? "nav-item active" : "nav-item sidebar_item"}>

                        <Link to='/UpcomingWebinar' className="nav-link">

                            <img src="static/assets/img/sidebaricons/upcomingWebinar.png" className="menu-icon bg-transparent p-0 m-0 shadow-none" />
                            {/* <Users className="menu-icon bg-transparent" /> */}
                            <span
                                className="menu-title"
                                style={{ display: (isopen || Expand) ? "" : "none" }}
                            >
                                Upcoming Webinar
                            </span>

                        </Link>

                    </li>

                    {/* <li
                        className={Open || active === "dashboard" ? "nav-item active" : "nav-item sidebar_item"}>

                        <Link to='/MeetingCreation' className="nav-link">

                            <img src="static/assets/img/nav/dashboard.png" className="menu-icon" />

                            <span
                                className="menu-title"
                                style={{ display: (isopen || Expand) ? "" : "none" }}
                            >
                                Meeting Creation
                            </span>

                        </Link>

                    </li> */}

                    <li
                        className={Open || active === "dashboard" ? "nav-item active" : "nav-item sidebar_item"}>

                        <Link to='/SeminarVideo' className="nav-link">

                           <img src="static/assets/img/sidebaricons/seminarVideo.png" className="menu-icon bg-transparent p-0 m-0 shadow-none" />
                            {/* <Video className="menu-icon bg-transparent" /> */}
                            <span
                                className="menu-title"
                                style={{ display: (isopen || Expand) ? "" : "none" }}
                            >
                                Seminar Video
                            </span>

                        </Link>

                    </li>


                    <li
                        className={Open || active === "dashboard" ? "nav-item active" : "nav-item sidebar_item"}>

                        <Link to='/WebinarVideo' className="nav-link">

                            <img src="static/assets/img/sidebaricons/webinarVideo.png" className="menu-icon bg-transparent p-0 m-0 shadow-none" />
                            {/* <Video className="menu-icon bg-transparent" /> */}
                            <span
                                className="menu-title"
                                style={{ display: (isopen || Expand) ? "" : "none" }}
                            >
                                Webinar Video
                            </span>

                        </Link>

                    </li>

                </ul>
            </nav>
        </div>
    );
}
